import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { PaymentIntent } from './types/Subscriptions';

interface Payload {
  currency: string;
  priceCodes: string[];
  billingCountry?: string;
  customerName?: string;
}

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<PaymentIntent>(
    'POST',
    `${APIV2_URL}/billing/subscriptions/create-pay-intent`,
    {
      data,
    },
  );
